import type { FC} from 'react';
import { memo } from 'react';
import type { FormSpyRenderProps } from 'react-final-form';
import { FormSpy } from 'react-final-form';
import Interceptor from '../../Interceptor';

type DirtyInterceptorProps = FormSpyRenderProps & {
    keepDirtyOnReinitialize: boolean;
};

const DirtyInterceptor: FC<DirtyInterceptorProps> = ({
    dirty,
    submitting,
    submitSucceeded,
    dirtySinceLastSubmit,
    keepDirtyOnReinitialize,
}) => {
    const hasUnsavedChanges = keepDirtyOnReinitialize ? (!submitSucceeded && dirty) || dirtySinceLastSubmit : dirty;
    return <Interceptor if={hasUnsavedChanges || submitting} />;
};

type Props = {
    /**
     * Should match the overarching <Form> component.
     */
    keepDirtyOnReinitialize: boolean;
};

const FormInterceptor: FC<Props> = memo(({ keepDirtyOnReinitialize }) => (
    <FormSpy
        subscription={{ dirty: true, submitting: true, submitSucceeded: true, dirtySinceLastSubmit: true }}
        component={renderProps => (
            <DirtyInterceptor {...renderProps} keepDirtyOnReinitialize={keepDirtyOnReinitialize} />
        )}
    />
));

export default FormInterceptor;
